import React from 'react';
//import  Navbar  from 'react-bootstrap/Navbar';
//import { Container } from 'react-bootstrap';
import { Nav, Navbar, Container, NavDropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import Canvas from '../src/Components/Canvas'


   

function App() {
  return (
    <div style={{ height: '100%', display:'flex', flex: 1, flexDirection: 'column' }}>

      <Canvas />
    </div>
  );
}

export default App;
